'use strict';

import CampaignSettingInterface from '../interfaces/icampaign-setting';

export default class CampaignSettingHTTPService extends CampaignSettingInterface {
  constructor(http, routes) {
    super()
    this.http = http;
    this.routes = routes;
  }
  getAllCampaignSettings() {
    return this.http.get(this.routes.getAllCampaignSettings);
  }
  getCampaignSettingById() {
    return this.http.get(this.routes.getCampaignSettingById);
  }
  addCampaignSetting(campaignSetting) {
    return this.http.post(this.routes.addCampaignSetting, null, null, campaignSetting);
  }
  updateCampaignSetting(campaignSetting) {
    return this.http.patch(this.routes.updateCampaignSetting, {
      id: campaignSetting.id
    }, null, campaignSetting);
  }
}
